import React from 'react';
import PaymentSwitch from './PaymentSwitch';
import UKPayeesContainer from '../../uk/main/containers/UKPayeeContainer';
import InternationalPayeesContainer from '../../international/InternationalPayeesContainer';

const MakePayment = ({ active, ukClick, intClick }) => {
    return (
        <div className="make-payment">
            <PaymentSwitch
                active={active}
                ukClick={ukClick}
                intClick={intClick}
            />
            {!active ? <UKPayeesContainer /> : <InternationalPayeesContainer />}
        </div>
    );
};

export default MakePayment;
